
<div class="container" style="border:1px solid #bebaba">
  <br />

  <div class="row indentContent">
    <div class="col-md-12">
      <h3 style="font-weight:bold">IMPORTANT DATES & DEADLINES</h3>
      <p>Below are key dates and deadlines to be aware of in this matter.</p>
      <div class="row" style="margin-left:5%;margin-right:5%; margin-top:3%">
        <div class="col-md-12">
          <div class="table-responsive">
            <table class="table table-bordered">
              <tbody>
                <tr>
                  <td style=" background-color: lightgray; text-align: center; font-weight: bold;vertical-align: middle; width: 50%">
                    Deadline for opting out
                  </td>
                  <td style="background-color:white; color:#3e4144; width:50%">
                    December 11, 2026
                  </td>

                </tr>
                <tr>
                  <td style=" background-color: lightgray; text-align: center; font-weight: bold;vertical-align: middle; width: 50%">
                    Deadline for Members of Settlement Class to object
                    to Settlement or other Settlement-related
                    matters (including attorneys’ fees, costs, and
                    service awards) and/or file Notice of Intention
                    to Appear
                  </td>
                  <td style="background-color:white; color:#3e4144; width:50%">
                    December 11, 2026
                  </td>
                <tr>
                  <td style=" background-color:lightgray; text-align:center; font-weight:bold;  vertical-align: middle; width:50%">
                    Deadline for submitting claims
                  </td>
                  <td style="background-color:white; color:#3e4144; width:50%">
                    February 10, 2027
                  </td>

                </tr>
                <tr>
                  <td style=" background-color: lightgray; text-align: center; font-weight: bold;vertical-align: middle; width: 50%">
                    Final Approval Hearing (including hearing on Petition for attorneys’ fees, costs, and service awards)
                  </td>
                  <td style="background-color:white; color:#3e4144; width:50%">
                    February 17, 2027 4:00 P.M. ET
                  </td>

                </tr>
              
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div style="width:80%; margin:0 auto; text-align: center; display:block; margin-top: 2%">
    <p>
      Note: These documents are in PDF format. To view the<br />
      documents, you will need <a href="https://get.adobe.com/reader/" target="_blank"
                                  style="color:#0071ce; font-weight:bold">Adobe Acrobat Reader</a>
      on your computer or other internet-enabled device.
    </p>
  </div>
  <div class="row text-center" id="inverse_row">
    <div class="col-md-12">
      <a href="https://get.adobe.com/reader/" target="_blank"><img src="../assets/adobe-pdf-icon.jpg" alt="Adobe Acrobat Reader" width="3%"></a>
    </div>
  </div>
  <br />
</div>
